import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import {
  FDDialog,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import useMobileLayout from 'Hooks/useMobileLayout';
import { AddOrEditHouseholdMemberLayout } from './AddOrEditHouseholdMemberLayout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['fullName'], { hidden: true }, overrideReadOnly);


export const AddHouseholdMember = ({
  resource, onCloseModal, isOpen, onSubmitSuccess,
}) => {
  const isMobile = useMobileLayout();

  return (
    <FDDialog
      open={isOpen}
      fullScreen={isMobile}
      onClose={onCloseModal}
      dialogWidth={'sm'}
    >
      <MetaResourceRenderer
        layout={AddOrEditHouseholdMemberLayout}
        LayoutProps={{
          onCloseModal,
        }}
        resource={resource}
        onSubmit={(res) => {
          onSubmitSuccess(res.resources().head());
          onCloseModal();
        }}
        metaOverrideSet={metaOverrideSet}
      />
    </FDDialog>
  );
};

AddHouseholdMember.propTypes = {
  resource: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
};
